import { useFeaturesForApiNames } from '../../../../../hooks/useFeatures';
import { useProductDetailsForArray } from '../../../../hooks/useProductDetails';
import { getHighlightedProductsForSkuCategory } from '../../../../utils/highlightedProductUtils';
import { isValidPaidProductLevel } from '../../../../utils/typeguards';
export const currentOrderedProductLevels = ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
export const usePaidUsersModal = ({
  skuCategoryName
}) => {
  var _paidProductResponse$;
  const highlightedProductsBySkuCategory = getHighlightedProductsForSkuCategory({
    skuCategoryName
  });
  const paidHighlightedProducts = highlightedProductsBySkuCategory.paidHighlightedProducts;
  const freeHighlightedProduct = highlightedProductsBySkuCategory.freeHighlightedProduct;
  const allHighlightedProducts = [...(freeHighlightedProduct ? [freeHighlightedProduct] : []), ...(paidHighlightedProducts || [])];
  const {
    features
  } = useFeaturesForApiNames(allHighlightedProducts);
  const paidProductResponse = useProductDetailsForArray({
    productApiNames: paidHighlightedProducts || []
  });
  const productsByName = paidProductResponse === null || paidProductResponse === void 0 || (_paidProductResponse$ = paidProductResponse.productDetails) === null || _paidProductResponse$ === void 0 ? void 0 : _paidProductResponse$.productsByName;
  const paidProductLevelProductApiNames = productsByName ? Object.keys(productsByName) : [];
  const paidProductLevels = paidProductLevelProductApiNames.reduce((acc, productApiName) => {
    var _productsByName$produ;
    const level = productsByName === null || productsByName === void 0 || (_productsByName$produ = productsByName[productApiName]) === null || _productsByName$produ === void 0 ? void 0 : _productsByName$produ.productLevel;
    if (level && isValidPaidProductLevel(level) && !acc.includes(level)) {
      acc.push(level);
    }
    return acc;
  }, []).sort((a, b) => currentOrderedProductLevels.indexOf(a) - currentOrderedProductLevels.indexOf(b));
  const productMap = Object.keys(productsByName || {}).reduce((acc, apiName) => {
    var _productsByName$apiNa;
    const level = productsByName === null || productsByName === void 0 || (_productsByName$apiNa = productsByName[apiName]) === null || _productsByName$apiNa === void 0 ? void 0 : _productsByName$apiNa.productLevel;
    if (level) {
      return Object.assign({}, acc, {
        [level]: apiName
      });
    }
    return acc;
  }, {});
  return {
    features,
    paidProductLevels,
    productMap
  };
};